import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { CompanyEntity } from './company.entity';

@Index('fk_client__id', ['fkClientId'], {})
@Index('fk_company__id', ['fkCompanyId'], {})
@Entity('client_company')
export class ClientCompanyEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientCompanies, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => CompanyEntity, (company) => company.clientCompanies, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;
}
